import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "readMore"]

  connect() {
    this.readMoreExpanded = false
    this.readMoreTouched = false
    this.readMoreAutoExpand = false
    if (this.hasListTarget) {
      this.listTarget.classList.remove("active")
    }
    if (this.hasListTarget) {
      this.observer = new MutationObserver((mutations) => this.handleMutations(mutations))
      this.observer.observe(this.listTarget, { childList: true })
    }
    this.scheduleUpdate()
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  toggle(event) {
    event.preventDefault()
    this.readMoreExpanded = !this.readMoreExpanded
    this.readMoreTouched = true
    this.scheduleUpdate()
  }

  reset() {
    this.readMoreExpanded = false
    this.readMoreTouched = false
    this.readMoreAutoExpand = false
    if (this.hasListTarget) {
      this.listTarget.classList.remove("active")
    }
    this.scheduleUpdate()
  }

  scheduleUpdate() {
    if (!this.hasListTarget || !this.hasReadMoreTarget) return
    window.requestAnimationFrame(() => this.update())
  }

  handleMutations(mutations) {
    const hasAddedNodes = mutations.some((mutation) => mutation.addedNodes.length > 0)
    if (hasAddedNodes) {
      this.readMoreAutoExpand = true
    }
    this.scheduleUpdate()
  }

  update() {
    if (!this.hasListTarget || !this.hasReadMoreTarget) return
    const items = Array.from(this.listTarget.children).filter(
      (item) => item.tagName === "LI"
    )
    const visibleItems = items.filter((item) => (
      !item.classList.contains("is-removed") && !item.classList.contains("tw-hidden")
    ))
    if (visibleItems.length === 0) {
      this.readMoreExpanded = false
      this.readMoreTouched = false
      this.readMoreAutoExpand = false
    }
    const hasOverflow = visibleItems.length > 3

    if (this.readMoreAutoExpand && hasOverflow) {
      this.readMoreExpanded = true
      this.readMoreTouched = true
      this.readMoreAutoExpand = false
    }

    if (!this.readMoreTouched) {
      this.readMoreExpanded = false
    } else if (!hasOverflow) {
      this.readMoreExpanded = false
    }

    this.readMoreTarget.style.display = hasOverflow ? "inline-block" : "none"
    this.readMoreTarget.textContent = ""
    this.listTarget.classList.toggle("active", this.readMoreExpanded)

    items.forEach((item) => item.classList.remove("is-collapsed"))

    if (!this.readMoreExpanded) {
      visibleItems.slice(3).forEach((item) => {
        item.classList.add("is-collapsed")
      })
    }
  }
}
